import React, { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
    Typography
  } from '@mui/material';
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';

//actions
import {
    clearRedux,
    openAccountApiKeyDeleteModal,
    deleteAccountApiKeys
} from 'Redux/actions';

const DeleteAccountApiKeys = (props) => {
    const dispatch = useDispatch();
    const { intl, callback } = props;
    const { messages } = intl;

    const {
        openDelete: open,
        selectedApiKeys: apiKeys,
        loadingDelete,
        deleteResponse: response
    } = useSelector(state => state.apiKeysRedux);

    useEffect(() => {
        return () => {
            dispatch(clearRedux("ACCOUNT_API_KEYS", {
                openDelete: false,
                selectedApiKeys: [],
                loadingDelete: false,
                deleteResponse: null
            }));
        }
    }, []);


    useEffect(() => {
        if (response && open) {
            if (response.error) {
               
            } else {
                callback("", true);
                handleClose();
            }
        }
    }, [response, open]);

    const handleClose = useCallback(() => {
        dispatch(openAccountApiKeyDeleteModal(false));
        dispatch(clearRedux("ACCOUNT_API_KEYS", {
            openDelete: false,
            selectedApiKeys: [],
            loadingDelete: false,
            deleteResponse: null
        }));
    });

    return (
        <Modal
            title={messages['accountApiKeys_deleteTitle']}
            open={open}
            position="right"
            size="small"
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: 24, overflowWrap: 'break-word' }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['accountApiKeys_deleteWarning']}
                    </Typography>

                    {
                        (apiKeys && apiKeys?.length) &&
                        <ul>
                            {
                                apiKeys.map((apiKey, key) => {
                                    return (
                                        <li key={key}>
                                            {apiKey?.name}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loadingDelete}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingDelete}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        dispatch(deleteAccountApiKeys(apiKeys));
                    }}
                    className="btn-blue"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default injectIntl(DeleteAccountApiKeys);